import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const ACTIVATE_EACASE_NEW_BILLING_INDICATOR = "ACTIVATE_EACASE_NEW_BILLING_INDICATOR";

export const service = async (eaCaseIds) => {
  const options: object = {
    url: '/Api/EaCaseApiController/ActivateEaCaseNewBillingIndicator',
    method: "POST",
    body: JSON.stringify(eaCaseIds),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(ACTIVATE_EACASE_NEW_BILLING_INDICATOR, service, mock);
